(function() {
  var colors = ['#FFD700', '#BF5FFF', '#FFFFFF', '#FFA500', '#E0AAFF'];
  document.addEventListener('mousemove', function(e) {
    for (var i = 0; i < 3; i++) {
      (function() {
        var p = document.createElement('div');
        var size = Math.random() * 8 + 4;
        var color = colors[Math.floor(Math.random() * colors.length)];
        var tx = (Math.random() - 0.5) * 60;
        var ty = (Math.random() - 0.5) * 60;
        p.style.cssText = 'position:fixed;width:'+size+'px;height:'+size+'px;left:'+(e.clientX-size/2)+'px;top:'+(e.clientY-size/2)+'px;background:'+color+';box-shadow:0 0 '+size+'px '+color+';border-radius:50%;pointer-events:none;z-index:99999;opacity:1;transition:opacity 0.8s,transform 0.8s;';
        document.body.appendChild(p);
        setTimeout(function(){ p.style.opacity='0'; p.style.transform='translate('+tx+'px,'+ty+'px) scale(0)'; }, 50);
        setTimeout(function(){ p.remove(); }, 850);
      })();
    }
  });
})();